import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/posts")({
  component: () => <div>Hello /_authenticated/feed/posts!</div>,
});
